
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';

function padding(s, len) {
	var len = len - (s + '').length;
	for (var i = 0; i < len; i++) {
		s = '0' + s;
	}
	return s;
};

export default {
	webRoot:Config.webRoot,
	getQueryStringByName: function(name) {
		var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
		var r = window.location.search.substr(1).match(reg);
		var context = "";
		if (r != null)
			context = r[2];
		reg = null;
		r = null;
		return context == null || context == "" || context == "undefined" ? "" : context;
	},
	formatDate: {
		format: function(date, pattern) {
			pattern = pattern || DEFAULT_PATTERN;
			return pattern.replace(SIGN_REGEXP, function($0) {
				switch ($0.charAt(0)) {
					case 'y':
						return padding(date.getFullYear(), $0.length);
					case 'M':
						return padding(date.getMonth() + 1, $0.length);
					case 'd':
						return padding(date.getDate(), $0.length);
					case 'w':
						return date.getDay() + 1;
					case 'h':
						return padding(date.getHours(), $0.length);
					case 'm':
						return padding(date.getMinutes(), $0.length);
					case 's':
						return padding(date.getSeconds(), $0.length);
				}
			});
		},
		parse: function(dateString, pattern) {
			var matchs1 = pattern.match(SIGN_REGEXP);
			var matchs2 = dateString.match(/(\d)+/g);
			if (matchs1.length == matchs2.length) {
				var _date = new Date(1970, 0, 1);
				for (var i = 0; i < matchs1.length; i++) {
					var _int = parseInt(matchs2[i]);
					var sign = matchs1[i];
					switch (sign.charAt(0)) {
						case 'y':
							_date.setFullYear(_int);
							break;
						case 'M':
							_date.setMonth(_int - 1);
							break;
						case 'd':
							_date.setDate(_int);
							break;
						case 'h':
							_date.setHours(_int);
							break;
						case 'm':
							_date.setMinutes(_int);
							break;
						case 's':
							_date.setSeconds(_int);
							break;
					}
				}
				return _date;
			}
			return null;
		}
	},
	storage: {
		set(key, value) {
			//对象必须序列化才能存入缓存
			localStorage.setItem(key, JSON.stringify(value));
		},
		get(key) {
			//反序列化
			return JSON.parse(localStorage.getItem(key));
		},
		remove(key) {
			localStorage.removeItem(key);
		}
	},
	dateFormat: function(row, column, cellValue, index) {
		const daterc =cellValue;// row[column.property]
		if (daterc != null && daterc!='') {
			var date = new Date(daterc);
			var year = date.getFullYear();
			/* 在日期格式中，月份是从0开始的，因此要加0
			 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
			 * */
			var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
			var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
			// 拼接
			return year + "-" + month + "-" + day
		}
		else{
			return "-"
		}
	},
	dateFormatEx: function(row, column, cellValue, index) {
		const daterc =cellValue;// row[column.property]
		if (daterc != null && daterc!='') {
			var date = new Date(daterc);
			var year = date.getFullYear();
			/* 在日期格式中，月份是从0开始的，因此要加0
			 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
			 * */
			var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
			var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
			var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
			var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
			var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
			// 拼接
			return year + "-" + month + "-" + day + " " + hours + ":" + minutes;
		}
		else{
			return "-"
		}
	},
	dealDateTime: function(cellValue) {
		const daterc =cellValue;// row[column.property]
		if (daterc != null && daterc!='') {
			var date = new Date(daterc);
			var year = date.getFullYear();
			/* 在日期格式中，月份是从0开始的，因此要加0
			 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
			 * */
			var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
			var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
			var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
			var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
			var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
			// 拼接
			return year + "-" + month + "-" + day + " " + hours + ":" + minutes+":"+seconds;
		}
		else{
			return ""
		}
	},
	dealDate: function(cellValue) {
		const daterc =cellValue;// row[column.property]
		if (daterc != null && daterc!='') {
			var date = new Date(daterc);
			var year = date.getFullYear();
			/* 在日期格式中，月份是从0开始的，因此要加0
			 * 使用三元表达式在小于10的前面加0，以达到格式统一  如 09:11:05
			 * */
			var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
			var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
			var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
			// 拼接
			return year + "-" + month + "-" + day
		}
		else{
			return ""
		}
	},
	dealQueryDateRange(filters,dataArr,key){
		if (dataArr && dataArr.length > 0) {
			filters[key] =dataArr[0];
			filters[key+'2'] = dataArr[1];
		}
		else {
			filters[key] = ""
			filters[key+'2'] = ""
		}
	},
	// @param backgroundColor 字符串 传入  #FFFBBC | FBC | FFBBCC 均可
	contrastTextColor(backgroundHexColor){
		let hex = backgroundHexColor
		// 如果当前传入的参数以 # 开头,去除当前的
		if (hex.startsWith('#')) {
		  hex = hex.substring(1);
		}
		// 如果当前传入的是 3 位小数值，直接转换为 6 位进行处理
		if (hex.length === 3) {
		  hex = [hex[0], hex[0], hex[1], hex[1], hex[2], hex[2]].join('')
		}
	  
		if (hex.length !== 6) {
		  throw new Error('Invalid background color.' + backgroundHexColor);
		}
	  
		const r = parseInt(hex.slice(0, 2), 16)
		const g = parseInt(hex.slice(2, 4), 16)
		const b = parseInt(hex.slice(4, 6), 16)
		
		if ([r,g,b].some(x => Number.isNaN(x))) {
		   throw new Error('Invalid background color.' + backgroundHexColor);
		}
	  
		const textColor = (r * 0.299 + g * 0.587 + b * 0.114) > 186 ? '#000000' : '#FFFFFF'
		return textColor
	},
	convertRGBToHex(rgb){
		const rgbRegex = /^rgb\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)$/
		const bg = rgb.match(rgbRegex);
		if (!bg) {
		  // 返回空字符串，在后面判断长度为 6 时候会报错。不在此处进行操作
		  return ''
		}
		return ("#" + hex(bg[1]) + hex(bg[2]) + hex(bg[3])).toUpperCase();
	},
	calc_additionFunc(data1,data2){// 加法
		let r1,r2,m;
		// 获取每个参数的小数的位数
		try{r1=data1.toString().split(".")[1].length}catch(e){r1=0}
		try{r2=data2.toString().split(".")[1].length}catch(e){r2=0}
		// 计算底数为10以最大小数位数为次幂的值
		m=Math.pow(10,Math.max(r1,r2));
		// 把所有参数转为整数后相加再除以次幂的值
		return (data1*m + data2*m)/m;
	  },
	  calc_subtractionFunc(data1,data2){// 减法
		let r1,r2,m,n;
		 // 获取每个参数的小数的位数
		 try{r1=data1.toString().split(".")[1].length}catch(e){r1=0}
		 try{r2=data2.toString().split(".")[1].length}catch(e){r2=0}
		 // 计算底数为10以最大小数位数为次幂的值
		 m=Math.pow(10,Math.max(r1,r2));
		 //精度长度以最大小数位数为长度
		 n=(r1>=r2)?r1:r2;
		 return ((data1*m-data2*m)/m).toFixed(n);
	  },
	  calc_multiplicationFunc(data1,data2) {// 乘法
		let m=0,s1=data1.toString(),s2=data2.toString();
		// 获取所有参数小数位长度之和
		try{m+=s1.split(".")[1].length}catch(e){}
		try{m+=s2.split(".")[1].length}catch(e){}
		// 替换掉小数点转为数字相乘再除以10的次幂值
		return Number(s1.replace(".",""))*Number(s2.replace(".",""))/Math.pow(10,m);
	  },
	  calc_divisionFunc(data1,data2) {// 除法
		let t1=0,t2=0,r1,r2;
		// 获取每个参数的小数的位数
		try{t1=data1.toString().split(".")[1].length}catch(e){}
		try{t2=data2.toString().split(".")[1].length}catch(e){}
		// 把所有参数的小数点去掉转为整数
		r1=Number(data1.toString().replace(".",""));
		r2=Number(data2.toString().replace(".",""));
		return (r1/r2)*Math.pow(10,t2-t1);
	  },
	yesOrNo: function(row, column, cellValue, index) {
		if(cellValue=="1") return "✓";
		else return "×";
	},
	showPic100: function( cellValue, index) {
		return "<a href='"+this.webRoot+cellValue+"' target='_blank'><img src='"+this.webRoot+cellValue+"' style='width:100px;height:100px'/></a>";
	},
	showPic80: function( cellValue, index) {
		if(cellValue==''){
			return '-'
		}
		return "<a href='"+this.webRoot+cellValue+"' target='_blank'><img src='"+this.webRoot+cellValue+"' style='width:80px;height:80px'/></a>";
	},
	showPic40: function( cellValue, index) {
		if(cellValue==''){
			return '-'
		}
		return "<a href='"+this.webRoot+cellValue+"' target='_blank'><img src='"+this.webRoot+cellValue+"' style='width:40px;height:40px'/></a>";
	},
	showHref: function(cellValue, index) {
		if(cellValue!=null && cellValue!=''){
			let html=""
			cellValue.split(',').map((v,idx)=>{
				if(idx==0){
					html+="<a href='"+this.webRoot+v+"' class='linkcolor' target='_blank'>查看</a>&nbsp;"
				}
				else{
					html+="<a href='"+this.webRoot+v+"'  class='linkcolor' target='_blank'>查看"+(idx+1)+"</a>&nbsp;"
				}
			})
			return html
		}
		return "-";
	},
	jsonToForm: function(data) {
		let formData = new FormData();
		for (var key in data) {
			let context="";
			if(data[key]==0 || data[key]!=null){
				if(data[key] instanceof Array){
					context=JSON.stringify(data[key])
				}
				else{
					context=data[key];
				}
			}
			formData.append("txt_" + key,context);
		}
		return formData;
	},
};
